export const sortPmsYears = (pmsYears) => {
  return (
    pmsYears
      ?.filter(
        (year) =>
          typeof year === "string" &&
          year.trim() !== "" &&
          year.split("-").length === 3
      )
      .sort((a, b) => {
        const yearA = parseInt(a.split("-")[2], 10);
        const yearB = parseInt(b.split("-")[2], 10);
        return yearB - yearA;
      })
      .map((year) => ({
        label: year,
        value: year,
      })) || []
  );
};